import { render } from "./ReportGeneric.vue?vue&type=template&id=63d4b3f6"
import script from "./ReportGeneric.vue?vue&type=script&lang=js"
export * from "./ReportGeneric.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__